import React from 'react'

export default () => (
    <footer>
        <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    Copyright {new Date().getFullYear()} By Paul Kimbrel
                </div>
            </div>
        </div>
    </footer>
    )
    
    


// WEBPACK FOOTER //
// ./src/components/footer.js